import { takeEvery, all, fork, takeLatest } from 'redux-saga/effects';
import { INIT_APP } from '../redux/types/login';
import { INIT_GET_FOLIO_LIST, LOGGED_IN_SUCCESS, LOGOUT, RILOGOUT } from '../redux/types/init';
import { initApp } from './login';
import { logout, rilogout } from './logout';
import { initGetFolioList, loggedInSuccess } from './init';

import { AUTHENTICATE_USER } from '../redux/types/authenticate';
import { authenticateUser } from './authenticate';
import { aboutUs } from './aboutUs';
import { NavApi } from './nav';
import { MFDetail, Category, DropFilter, STPCategory } from './mfDetail';
import { PassiveCategory, PassiveDetail } from './passivefund';
import { getMaster } from './onboarding/master';
import { callCVL, validateNewInvPAN, panDetail, clientDetails, getIfscBankDet, saveBankDetails, saveNomineeDetails, saveFatcaDetails, savePersonalDetails, getKycFolioData } from './onboarding/personal';
import { portFolioCall, addToCart, singleCartData, getSipDashboard, getSwpDashboard, getStpDashboard, FolioDescription, getAllFolios, getCartCount , portAllSchemeDataCall, getFundCategoryNew} from './trans/transSaga';
import { getCartData } from './trans/cartSaga';
import { getFolioKary } from './trans/karvyFolio';
import { selectedRIData, RIStatus } from './trans/category';
import { orderBookCall } from './trans/orderBook';
import { setBankDetails, getFolioDetails, setFolioValue } from './manageBank';
import { EMANDATE } from '../redux/types/emandate';
import { emandate } from './emandate'
import { MENU_ROLE_WISE, MASTER_MENU } from '../redux/types/initApp'; //POPUP_MENU--> Code commented for DXTech issue
import { menuRoleWise, masterMenu } from './initApp'; //popupmenu--> Changes made for handling Popup --Abhishek // Code commented for DXTech issue
import { FOLIO_LIST_KARVY, GET_REGISTERED_BANKS, ORDER_GENERATION, PAYMENT_REQUEST, GET_PG_RESPONSE, VALIDATE_BROKER_CODE, FOLIO_BROKER_LIST } from "../redux/types/quickbuy";

import {
    FolioListKarvy, GetRegisteredBanks, OrderGeneration, PaymentRequest, GetPGResponse, validateBrokerCode,
    folioBrokerList, getBucketID, dit_URLDetails, selectedOption
} from './quickbuy';
import { ReportSend, Bitaly_link } from './reports';
import { REPORT_SEND, BITALY_LINK } from '../redux/types/reports';

import { paymentRequest, paymentResponse } from '../redux/actions/quickbuy';
import { elssData, elssPdfDownload } from './elssReport';
import { ELSS_Data, ELSS_PDFDOWNLOAD } from '../redux/types/elssReport';
import { FABSCHEME, FOLIODETAILS, FREQUENCYCALCULATOR, WITHDRAWPLOTTING } from '../redux/types/fabPlan';
import { fabScheme, folioDetails, frequencyCalculator, withdrawPlotting } from './fabPlan';
import { REMOVE_COOKIE } from '../redux/types/removeCookies';
import { removeCookie } from './removeCookie';

function* rootSaga() {
    yield all([
        takeEvery(INIT_APP, initApp), // (ACTION, SAGA)
        takeEvery(INIT_GET_FOLIO_LIST, initGetFolioList),
        fork(aboutUs),
        fork(NavApi),
        fork(Category),
        fork(MFDetail),
        fork(DropFilter),
        fork(PassiveCategory),
        fork(PassiveDetail),
        fork(getMaster),
        fork(callCVL),
        fork(validateNewInvPAN),
        fork(panDetail),
        fork(clientDetails),
        fork(getKycFolioData),
        fork(getIfscBankDet),
        fork(saveBankDetails),
        fork(saveNomineeDetails),
        fork(saveFatcaDetails),
        fork(savePersonalDetails),
        fork(portFolioCall),
        fork(portAllSchemeDataCall),
        fork(getFundCategoryNew),
        fork(STPCategory),
        fork(addToCart),
        // fork(singleCartData),
        fork(getSipDashboard),
        fork(FolioDescription),
        fork(getSwpDashboard),
        fork(getStpDashboard),
        fork(getFolioDetails),
        fork(getCartCount),
        // fork(setBankDetails),
        fork(setFolioValue),
        fork(orderBookCall),
        fork(getCartData),
        fork(getAllFolios),
        fork(getFolioKary),
        fork(selectedRIData),
        fork(RIStatus),


        takeEvery(LOGGED_IN_SUCCESS, loggedInSuccess),
        takeEvery(LOGOUT, logout),
        takeEvery(RILOGOUT, rilogout),
        takeEvery(AUTHENTICATE_USER, authenticateUser),
        //menu
        takeLatest(MENU_ROLE_WISE, menuRoleWise),
        takeLatest(MASTER_MENU, masterMenu),
        takeLatest(EMANDATE, emandate),
        // takeLatest(POPUP_MENU, popupmenu), //Changes made for handling Popup --Abhishek //Code commented for DXTech issue

        takeLatest(FOLIO_LIST_KARVY, FolioListKarvy),
        takeLatest(GET_REGISTERED_BANKS, GetRegisteredBanks),
        takeLatest(ORDER_GENERATION, OrderGeneration),
        takeLatest(PAYMENT_REQUEST, PaymentRequest),
        takeLatest(GET_PG_RESPONSE, GetPGResponse),
        takeLatest(VALIDATE_BROKER_CODE, validateBrokerCode),
        takeLatest(FOLIO_BROKER_LIST, folioBrokerList),
        fork(dit_URLDetails),//dit query params details
        fork(selectedOption),
        takeLatest(ELSS_Data, elssData),
        takeLatest(ELSS_PDFDOWNLOAD, elssPdfDownload),
        takeLatest(FABSCHEME, fabScheme),
        takeLatest(FREQUENCYCALCULATOR, frequencyCalculator),
        takeLatest(FOLIODETAILS, folioDetails),
        takeLatest(WITHDRAWPLOTTING, withdrawPlotting),

        takeLatest(BITALY_LINK, Bitaly_link),
        takeLatest(REPORT_SEND, ReportSend),

        takeLatest(REMOVE_COOKIE, removeCookie)


    ]);
}

export default rootSaga;